export default __webpack_public_path__ + "static/media/standards.8c381fa0.svg";